import { styled } from '@linaria/react';
import { fonts, layout, semantic, space } from '../../theme/tokens';

export const MobileTrigger = styled.button`
  display: none;

  @media screen and (max-width: 600px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${space['space-050']};
    width: 100%;
    padding: ${space['space-300']} ${space['space-400']};
    background: ${semantic.bg.surfaceSubtle};
    border: none;
    border-radius: 28px;
    cursor: pointer;
    font-family: ${fonts.body};
    color: ${semantic.text.primary};
    --jp-trigger-title: ${semantic.text.primary};

    &[data-image-overlay='true'] {
      background: ${semantic.bg.overlayBlur};
      backdrop-filter: blur(${space['space-200']});
      --jp-trigger-title: ${semantic.text.inverse};
    }
  }
`;

export const MobileTriggerTitle = styled.span`
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.semiBold};
  color: var(--jp-trigger-title, ${semantic.text.primary});
  text-align: center;
  overflow-wrap: break-word;
  max-width: 100%;
`;

export const MobileTriggerSubtitle = styled.span`
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
  text-align: center;
  overflow-wrap: break-word;
  max-width: 100%;
`;

export const MobileModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: ${semantic.bg.canvas};
  z-index: ${layout.zIndexModal};
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;
